import { type CellContext } from '@tanstack/react-table';

import { storage } from 'src/registry/utils/storage';

const TIME_FORMAT: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
};

const formatTime = (date: string | Date, locale: string = 'bg-BG'): string => {
    const d = typeof date === 'string' ? new Date(date) : date;
    return d.toLocaleTimeString(locale, { ...TIME_FORMAT });
};

export function CellDatetime<TData, TValue>({ getValue }: CellContext<TData, TValue>) {
    const value = getValue();
    const locale = storage.getLanguage();
    if (!value) return null;

    const datetime = new Date(value.toString());
    const formattedDate = datetime ? new Date(datetime.toString()).toLocaleDateString(locale) : '';
    const formattedTime = datetime ? formatTime(datetime, locale) : '';

    return (
        <div className="flex flex-col gap-0 whitespace-nowrap">
            <span>{formattedTime}</span>
            <span className="-mt-px whitespace-nowrap text-gray-500">{formattedDate}</span>
        </div>
    );
}
